import { useMemo } from "react";
import { useSelector } from "react-redux";

export const PERMISSION_MODE = Object.freeze({
  ALL: "ALL",
  OR: "OR",
});

export const usePermissionCheck = () => {
  const user_permissions = useSelector((state) => state.auth.permissions);

  const checkPermission = (permissions, mode = PERMISSION_MODE.OR) => {
    if (!permissions || Object.keys(permissions).length === 0) return true;
    if (!user_permissions) return false;

    const entries = Object.entries(permissions);

    return entries[mode === "ALL" ? "every" : "some"](([key, reqPerm]) => {
      const userPerm = user_permissions[key] ?? 0;

      if (Array.isArray(reqPerm)) {
        // Nếu truyền vào mảng quyền
        if (mode === "ALL") {
          // Tất cả quyền trong mảng phải có
          return reqPerm.every((p) => (userPerm & p) === p);
        } else {
          // OR: chỉ cần 1 quyền trong mảng có
          return reqPerm.some((p) => (userPerm & p) === p);
        }
      } else {
        // Nếu truyền vào số nguyên gộp (giữ nguyên behavior cũ)
        return (userPerm & reqPerm) === reqPerm;
      }
    });
  };
  return checkPermission;
};

export const CPermission = ({
  mode = PERMISSION_MODE.OR,
  children,
  permissions,
}) => {
  //#region Data
  const user_permissions = useSelector((state) => state.auth.permissions);

  const checkPermission = usePermissionCheck();

  const isAllowed = useMemo(
    () => checkPermission(permissions, mode),
    [mode, permissions, user_permissions]
  );
  //#endregion

  //#region Render
  return <>{isAllowed ? children : ""}</>;
  //#endregion
};
